import { render, staticRenderFns } from "./DeviceNoAppsFound.vue?vue&type=template&id=48b27efe&scoped=true"
import script from "./DeviceNoAppsFound.vue?vue&type=script&lang=js"
export * from "./DeviceNoAppsFound.vue?vue&type=script&lang=js"
import style0 from "./DeviceNoAppsFound.vue?vue&type=style&index=0&id=48b27efe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48b27efe",
  null
  
)

export default component.exports